import _ from 'lodash';
import { QueryString } from '~/utils';
import { del, get, patch, post, put } from './agent';

const projectTasks =
  (projectTasksUrl) =>
  (id = '') => {
    const url = _([projectTasksUrl, id]).compact().join('/');

    return {
      get: (query = {}) => get(url.concat(new QueryString(query, { multi: true }).toString(true))),
      options: (query = {}) =>
        get(url.concat('/options').concat(new QueryString(query, { multi: true }).toString(true))),
      getExport: (query = {}, headers = {}) =>
        get(url.concat('/export').concat(new QueryString(query, { multi: true }).toString(true)), headers),
      history: () => get(url.concat('/history')),
      hasDependencies: () => get(url.concat('/has-dependencies')),
      scheduledSuccessors: (body) => post(url.concat('/scheduled-successors'), body),
      descendants: () => get(url.concat('/descendants')),
      role: (query = {}) => get(url.concat('/role').concat(new QueryString(query).toString(true))),
      member: (query = {}) => get(url.concat('/member').concat(new QueryString(query).toString(true))),
      upsert: (body) => (id ? patch : post)(url, body),
      delete: () => del(url),
      createFromTemplates: ({ ids }) => post(url.concat('/create-from-templates'), { ids }),
      clone: (body) => post(url.concat('/clone'), body),
      order: (body) => patch(url.concat('/order'), body),
      setRecordStatus: ({ recordStatusId }) => put(url.concat('/record-status'), { recordStatusId }),
      setTaskCategory: ({ projectTaskCategoryId }) => put(url.concat('/task-category'), { projectTaskCategoryId }),
      timeEntryIds: () => get(url.concat('/time-entry-ids')),
      allocationIds: () => get(url.concat('/allocation-ids')),
      moveTime: ({ targetTaskId, ids }) => post(url.concat('/move-time'), { targetTaskId, ids }),
      moveAllocations: ({ targetTaskId, ids }) => post(url.concat('/move-allocations'), { targetTaskId, ids }),
      bulkDelete: (ids) => post(url.concat('/bulk-delete'), { ids }),
      bulkSetRecordStatus: (ids, body) => post(url.concat('/bulk-set-record-status'), { ids, ...body }),
      bulkSetStatus: (ids, body) => post(url.concat('/bulk-set-status'), { ids, ...body }),
      bulkSetTaskCategory: (ids, body) => post(url.concat('/bulk-set-task-category'), { ids, ...body }),
      get list() {
        const listUrl = _([projectTasksUrl, 'list', id]).compact().join('/');
        return {
          get: (query = {}) => get(listUrl.concat(new QueryString(query, { multi: true }).toString(true))),
          update: (body) => patch(listUrl, body),
        };
      },
      get board() {
        const boardUrl = _([projectTasksUrl, 'board', id]).compact().join('/');
        return {
          get: (query = {}) => get(boardUrl.concat(new QueryString(query, { multi: true }).toString(true))),
          update: (body) => patch(boardUrl, body),
        };
      },
    };
  };

export default projectTasks;
